import { ofType } from 'redux-observable';
import get from 'lodash.get';
import { of, EMPTY, concat } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import Global from '../../../store/global-selectors';
import * as PagingActions from '../../../store/paging/paging.actions';
import * as AlertsGridActions from '../../../store/alerts/grid/alerts.grid.actions';
import * as OrdersApi from '../../../store/orders/orders.api';
import * as Actions from './alerts.details.actions';
import { ShipTogetherHelperService } from '../../../services/ship-together-helper-service';
import { bulkLoadFulfillmentPlans$ } from '../../bulkload/bulkload.observables';

const pagingViewName = 'alerts.details';

export const getAlertDetailsEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.GET_ALERT_DETAILS),
    mergeMap((action) => {
      const state = getState();
      const stateAlertId = Global.selectAlertsDetailsAlertId(state);
      const actionAlertId = get(action, 'alertId');
      const pagingStats = Global.selectPagingViewPagingStats(state, {
        viewName: pagingViewName,
      });
      const requestPage = actionAlertId !== stateAlertId ? get(pagingStats, 'page', 1) : 1;
      const requestPageSize = get(pagingStats, 'pageSize', 100);

      const alertId = actionAlertId || stateAlertId;

      if (!alertId) {
        return EMPTY;
      }

      // once the alert is dismissed we can't get it from redux, may want to store these salesOrderGuids differently to support this
      const alert = Global.selectAlertsGridAlertFromAlertId(state, { alertId }) || Global.selectAlertsDetailsAlertDetails(state);
      if (!alert) {
        return EMPTY;
      }

      return OrdersApi.getOrdersInShipmentsMode('awaiting-shipment', requestPage, requestPageSize, {
        filter: { fulfillmentPlanIds: alert.fulfillmentPlanIds },
      }).pipe(
        mergeMap(({ currentPageFulfillmentPlanIds, page, pageSize, totalCount }) => {
          return concat(
            of(PagingActions.setInitialViewPageStats(pagingViewName, page, pageSize, totalCount)),
            of(
              Actions.getAlertDetailsSuccess({
                ...alert,
                orders: currentPageFulfillmentPlanIds,
              }),
            ),
          );
        }),
        catchError(() => {
          return of(Actions.getAlertDetailsFailure());
        }),
      );
    }),
  );
};

export const getShipTogetherOrdersEpic = (action$, { getState }) =>
  action$.pipe(
    ofType(Actions.SHIP_ORDERS_TOGETHER_FROM_ALERT_DETAILS),
    mergeMap(() => {
      const state = getState();
      const fulfillmentPlanIds = Global.selectSelectedOrdersIds(state) || [];
      return bulkLoadFulfillmentPlans$(fulfillmentPlanIds).pipe(
        mergeMap(() => {
          const orders = ShipTogetherHelperService.getShipTogetherSelectedOrders(state, fulfillmentPlanIds);
          return concat(of(AlertsGridActions.getShipTogetherOrdersSuccess(orders)), of(AlertsGridActions.shipOrdersTogetherFromAlerts()));
        }),
        catchError(() => EMPTY),
      ); // TODO: handle error case
    }),
  );
